import type { ImageLoaderConfig } from '@angular/common';
import { IMAGE_LOADER } from '@angular/common';
import { inject } from '@angular/core';

import { EnvironmentService } from '../environment/environment.service';

export const provideNgOptimizedImageInitializer = () => {
	return {
		provide: IMAGE_LOADER,
		useFactory: () => {
			const environment = inject(EnvironmentService);

			return (config: ImageLoaderConfig) => {
				if (config.loaderParams?.['customUrl']) {
					return config.src;
				}

				const WIDTH = 'width';
				const HEIGHT = 'height';
				const CROP = 'crop';

				const src = `https://${environment.assets}/${config.src}`;
				const queryParams: string[] = [];

				if (config.width) {
					queryParams.push(`${WIDTH}=${config.width}`);
					// This is needed in case someone wants to use loaderParams and `disableOptimizedSrcSet`
				} else if (config.loaderParams?.[WIDTH]) {
					queryParams.push(`${WIDTH}=${config.loaderParams[WIDTH]}`);
				}

				if (!config.isPlaceholder) {
					let height = config.loaderParams?.[HEIGHT];
					if (height) {
						/*
						 * ImageLoaderConfig.width is automatically multiplied by the
						 * DPR, but ImageLoaderConfig.height isn't yet supported, so we
						 * need to multiply the height ourselves in order to maintain
						 * the desired aspect ratio on DPR > 1 devices.
						 *
						 * See: https://github.com/angular/angular/issues/51723
						 **/
						if (config.width && config.loaderParams?.[WIDTH]) {
							height *= config.width / config.loaderParams?.[WIDTH];
						}

						queryParams.push(`${HEIGHT}=${height}`);
					}

					if (config.loaderParams?.[CROP]) {
						queryParams.push(`${CROP}=true`);
					}
				}

				if (queryParams.length) {
					return src + (src.includes('?') ? '&' : '?') + queryParams.join('&');
				}

				return src;
			};
		},
	};
};
